function init_search() {
    // Initialize both desktop and mobile search elements
    initializeSearchElement('#nav-search');
    initializeSearchElement('#nav-search-mobile');
}

function initializeSearchElement(selector) {
    let element = document.querySelector(selector);
    if (!element) {
        // Element doesn't exist, skip initialization
        return;
    }
    if (element.tomselect) {
        // Already initialized
        return;
    }

    var search = new TomSelect(selector, {
        valueField: 'name',
        labelField: 'name',
        searchField: 'name', // fetch remote data
        load: function (query, callback) {
            // Validate minimum 2-character requirement before making API calls
            if (!query || query.length < 2) {
                // Return empty results immediately for queries shorter than 2 characters
                callback([]);
                return;
            }

            // Track this fetch on the shared window-level counter so it is
            // observable to the same test tooling that watches jQuery.active and
            // Turbo visits (wait_for_ajax). Incremented before the fetch and
            // balanced in a finally on success, error, and abort. The <2-char
            // early return above does NOT fetch, so it is intentionally not wrapped.
            window.__pendingFetchRequests = (window.__pendingFetchRequests || 0) + 1;

            fetch(`/api/items/list?` + new URLSearchParams({ name: query }).toString())
                .then((response) => {
                    return response.json();
                }).then((json) => {
                const sortedItems = json.data.items.sort((a, b) => (a.name?.toLowerCase() || '').localeCompare(b.name?.toLowerCase() || ''));
                callback(sortedItems);
            }).catch((error) => {
                console.error('Search request failed:', error);
                callback();
            }).finally(() => {
                window.__pendingFetchRequests = Math.max((window.__pendingFetchRequests || 0) - 1, 0);
            });

        }, // custom rendering functions for options and items
        render: {
            option: function (item, escape) {
                return `<div class="py-2 d-flex">
                            <div>
                                <div class="mb-1">
                                    <span class="h6">
                                        ${escape(item.name)}
                                    </span>
                                    <span id = "${escape(item.name)}-id" class="d-none text-muted">${escape(item.id)}</span>
                                </div>
                            </div>
                        </div>`;
            }, item: function (item, escape) {
                return `<div class="py-2 d-flex">
                            <div>
                                <div class="mb-1">
                                    <span class="h6">
                                        ${escape(item.name)}
                                    </span>
                                    <span id = "${escape(item.name)}-id" class="d-none text-muted">${escape(item.id)}</span>
                                </div>
                            </div>
                        </div>`;
            }
        }, onChange: function (value) {
            let id = value + '-id';
            let link = $(`#${id}`).text();
            window.location.href = `/devices/update?device=${link}`;
        }
    });
}

$(document).on('turbo:load', init_search);